import {removeDuplicates, sortByKey} from 'presentation/utils';

import {Units} from 'presentation/modules/booking/shared/store/useUnitsListStore/types';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {TelemedicineEnum} from 'presentation/modules/booking/shared/constants/telemedicineEnum';

export const formatHealthUnit = (
	units: Units<FlowEnum.HEALTH>[],
	sortUnitsBy: keyof Units<FlowEnum.HEALTH>,
) => {
	const filterDuplicate = removeDuplicates(units);
	const sortedUnits = filterDuplicate && sortByKey(filterDuplicate, sortUnitsBy);
	const teleUnitIndex = sortedUnits?.findIndex(
		unit => unit?.telemedicine === TelemedicineEnum.IS_TELEMEDICINE,
	);

	if (teleUnitIndex !== -1) {
		const splicedTeleUnit = sortedUnits?.splice(teleUnitIndex, 1);

		return [...splicedTeleUnit, ...sortedUnits];
	}

	return sortedUnits;
};
